import * as React from "react";

const Help = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer12"
      fill="none"
      fillOpacity="1"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
    >
      <path
        id="path46"
        strokeDasharray="none"
        strokeDashoffset="1.68"
        strokeWidth="0.4"
        d="M6.818.496a2.55 2.55 0 0 1-2.729 1.9A2.55 2.55 0 0 1 1.804-.019a2.55 2.55 0 0 1 2.049-2.62 2.55 2.55 0 0 1 2.895 1.637"
        opacity="1"
        transform="rotate(46.807)"
      ></path>
      <path
        id="path47"
        strokeDasharray="7.51904, 0.751904"
        strokeDashoffset="7.369"
        strokeWidth="0.501"
        d="M3.175 4.746V3.744a.7.7 113.493 0 1 .223-.512l.364-.34a.606.606 85.984 0 0-.066-.94c-.288-.201-.765-.206-1.008.052a.57.57 0 0 0-.172.377"
        opacity="1"
        transform="matrix(.79797 0 0 .79797 .497 .462)"
      ></path>
      <path
        id="path48"
        strokeDasharray="none"
        strokeDashoffset="5.88"
        strokeWidth="0.4"
        d="m3.88 5.046 1.163.342a.283.283 131.28 0 0 .338-.386l-.456-1.033"
        opacity="1"
        transform="translate(.424 .265)"
      ></path>
    </g>
  </svg>
);

export default Help;
